import Vue from 'vue'
import Router from 'vue-router'
/*import vue file template:import %name from '%path'
 */
/*start:import vue file*/
/*end:import vue file*/
Vue.use(Router)

export default new Router({
  routes: [
    /*routes object template:{
     path: '/%name',
     name: '%name',
     component: r => require.ensure([], () => r(require('%path')), 'page-%name'),
     children: [
     %children:%name
     ]
     },
     */
    /*start:routes object*/
{
     path: '/station',
     name: 'station',
     component: r => require.ensure([], () => r(require('./pages/station/index.vue')), 'page-station'),
     children: [
     
     ]
     },
     /*end:routes object*/
  ]
})
